
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag-generator",
      function () {
        return require("private-next-pages/tag-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tag-generator"])
      });
    }
  